import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { PAYROLL, STATUS_IDS } from '../../../services/util/globalConstant';
import MultiSelect from '../../molecules/MultiSelect';

function SelectStatus({ selectedStatusList, onChange, excluded }) {
  const availableStatusList = STATUS_IDS.filter((statusId) => !excluded.includes(statusId));
  const options = availableStatusList.map((statusId) => (
    <Select.Option
      key={`status-${statusId}`}
      value={statusId}
    >
      {PAYROLL.status[statusId]}
    </Select.Option>
  ));

  const areAllStatusSelected = selectedStatusList.length === availableStatusList.length;
  return (
    <Label label="Operação">
      <MultiSelect
        placeholder="Selecione uma ou mais"
        maxTagTextLength={5}
        maxTagCount={1}
        value={selectedStatusList}
        areAllSelected={areAllStatusSelected}
        onChangeAllSelected={() => {
          if (areAllStatusSelected) {
            return onChange([]);
          }

          return onChange(availableStatusList);
        }}
        onChange={(values) => onChange(values)}
      >
        {options}
      </MultiSelect>
    </Label>
  );
}

SelectStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  excluded: PropTypes.arrayOf(PropTypes.number),
  selectedStatusList: PropTypes.arrayOf(PropTypes.oneOf(STATUS_IDS)).isRequired,
};

SelectStatus.defaultProps = {
  excluded: [],
};

export default SelectStatus;
